import 'react-hot-loader/patch';
import React from 'react';
import {Page} from 'react-onsenui';
import './styles/loader.scss';

export default class Loader extends React.Component {

  render() {
    return (
      <Page>
        <div className={'spinner-icon'}>
          <svg className={'spinner'} viewBox={'25 25 50 50'}>
            <circle className={'path'} cx="50" cy="50" fill="none" r="20" strokeMiterlimit={'10'} strokeWidth={'4'}></circle>
          </svg>
        </div>
      </Page>
    );
  }
}


// WEBPACK FOOTER //
// ./src/loader.jsx